import TableLite from './src/components/TableLiteTs.vue';

export default TableLite;